import script from "./account-main-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./account-main-list.vue?vue&type=script&lang=tsx&setup=true"

import "./account-main-list.vue?vue&type=style&index=0&id=2c0d7281&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0d7281"]])

export default __exports__